import React, { useState } from "react";
import {
  FiCopy,
  handleCopy,
} from "@/components/common/commonFunction/handleCopy";

const placeholderData = { input: "Ex. 5", output: "125" };
function CubeAndCuberoot() {
  const [inputValue, setInputValue] = useState("");
  const [result, setResult] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    setResult("");
    setIsCopied(false);
    setErrorMessage(value === "" ? null : "");
  };

  const validateForm = () => {
    if (!inputValue) {
      setErrorMessage("* Please enter a number");
      return false;
    }
    return true;
  };

  const handleConversion = () => {
    if (!validateForm()) return;
    const operation = document.getElementById("operationSelector").value;
    const numericValue = parseFloat(inputValue);
    if (operation === "Cube Root") {
      setResult(Math.cbrt(numericValue).toFixed(2));
    } else {
      setResult(Math.pow(numericValue, 3));
    }
    setIsCopied(false);
  };

  return (
    <>
      <div className="commom-box-new">
        <div className="input-new">
          <input
            type="number"
            placeholder={placeholderData.input}
            value={inputValue}
            onChange={handleInputChange}
            className={errorMessage ? "error-input" : ""}
          />
          {errorMessage && (
            <span className="text-sm text-red-700">{errorMessage}</span>
          )}
        </div>
      </div>

      <div className="commom-box-new truncate-text-top-alignment">
        <div className="input-new">
          <select id="operationSelector">
            <option value="Cube">Cube</option>
            <option value="Cube Root">Cube Root</option>
          </select>
        </div>
      </div>

      <div className="button lowercase-center-alignment">
        <button onClick={handleConversion}>Convert</button>
      </div>

      {result && (
        <div className="commom-box-new">
          <div className="copy-textarea-icon-alignment">
            <FiCopy
              onClick={() => {
                handleCopy(result);
                setIsCopied(true);
              }}
            />
            {isCopied && <span>Copied</span>}
          </div>
          <div className="input-new">
            <input
              type="text"
              value={result}
              placeholder={placeholderData.output}
              readOnly
              className="text-black"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default CubeAndCuberoot;
